<template>
	<div class="bind-insurance-again">
		<div class="tab">
			<a
				href="javascript:;"
				@click="changeHash('face')"
				:class="{ focus: focusATab == 'face', hide: hideTab == 'face' }"
				>人脸识别</a
			><a
				href="javascript:;"
				@click="changeHash('sms')"
				:class="{ focus: focusATab == 'sms', hide: hideTab == 'sms' }"
				>短信验证</a
			>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	data() {
		return {
			appTitle: '绑定保单二次验证',
			focusATab: 'face',
			hideTab: '',
			bindAgainParam: '',
		};
	},
	created() {
		let bindAgainParam = window.sessionStorage.getItem('bindAgainParam');
		if (bindAgainParam) {
			this.bindAgainParam = JSON.parse(bindAgainParam);
		}
		this.focus();
	},
	updated() {
		this.hide();
		this.focus();
	},

	methods: {
		hide() {
			if (this.bindAgainParam) {
				if (this.bindAgainParam.cardType != 'I') {
					this.hideTab = 'face';
				} else if (this.bindAgainParam.mobileList.length == 0) {
					this.hideTab = 'sms';
				}
			}
		},
		focus() {
			let hash = location.hash;
			if (hash.indexOf('sms') != -1) {
				this.focusATab = 'sms';
			} else {
				this.focusATab = 'face';
			}
		},
		changeHash(tag) {
			if (this.focusATab == tag) return;
			if (tag == 'face') {
				this.$router.replace({ path: 'face' });
			} else {
				this.$router.replace({ path: 'sms-m' });
			}
			this.focus();
		},
	},
};
</script>

<style scoped>
.tab {
	height: 0.63rem;
	overflow: hidden;
}
.tab a {
	display: inline-block;
	width: 50%;
	height: 0.61rem;
	font-size: 0.14rem;
	line-height: 0.61rem;
	text-align: center;
	color: #bcbcbc;
	border-bottom: 2px solid #fff;
}
.hide {
	display: none;
}
.tab a.focus {
	color: #333;
	border-bottom: 2px solid #4181ff;
}
</style>
